'use client';
import { useSearchParams } from 'next/navigation';
import React, { FC, useEffect, useState } from 'react';

import UnsubscribePopup from '@/components/popups/UnsubscribePopup';

export const UNSUBSCRIBE_KEY = 'unsubscribeToken';

const UnsubscribeDynamic: FC = () => {
  const [showPopup, setShowPopup] = useState(false);
  const searchParams = useSearchParams();

  useEffect(() => {
    const tokenExists = searchParams.get(UNSUBSCRIBE_KEY);
    if (tokenExists) {
      setShowPopup(true);
    } else {
      setShowPopup(false);
    }
  }, []);

  return showPopup ? <UnsubscribePopup onClose={() => setShowPopup(false)} /> : null;
};

export default UnsubscribeDynamic;
